const Scale = function() {
    var ku_cache = null;
    var wb_cache = null;

    Object.defineProperty(this, "ku", {
        set: (ku) => {
            ku = parseFloat(ku);
            ku_cache = ku;
            window.document.documentElement.style.setProperty("--ku", `${ku}`);
            window.document.documentElement.style.setProperty("--wb_base", `${ku}in`);
        },
        get: () => {
            if (ku_cache !== null) {
                return ku_cache;
            }
            ku_cache = parseFloat(getComputedStyle(window.document.documentElement).getPropertyValue("--wb_base"));
            return ku_cache;
        }
    });

    Object.defineProperty(this, "wb", {
        set: (wb) => {
            wb_cache = wb;
        },
        get: () => {
            if (wb_cache !== null) {
                return wb_cache;
            }
            let wb = getComputedStyle(document.documentElement).getPropertyValue("--wb");
            wb = wb.trim().replace(/^calc/, "").replace(/in/, "*96");
            wb = wb.replace(/[^-()\d/*+.]/g, ""); // sanitizer
            wb = eval(wb); // eslint-disable-line no-eval
            wb_cache = wb;
            return wb;
        }
    });

    Object.defineProperty(this, "font_factor", {
        set: (font_factor) => {
            font_factor = parseFloat(font_factor);
            window.document.documentElement.style.setProperty("--font_factor", `${font_factor}`);
        },
        get: () => {
            return parseFloat(getComputedStyle(window.document.documentElement).getPropertyValue("--font_factor"));
        }
    });
};

export default Scale;
